import crypto from 'crypto';

(function () {
    'ngInject';

    angular.module('app.shared.services').factory('MelcoAPIService', melcoAPIService);

    function melcoAPIService(HttpService, UsersAPIService) {
        const baseURL = 'https://client.livedesignerfusion.com';

        function getAuthString(username, apikey, uri) {
            const str = `${username}:${apikey}:${uri}`;
            return crypto.createHash('md5').update(Buffer.from(str, 'utf-8')).digest('hex').toUpperCase();
        }

        async function getMetaData(referenceId) {
            var user = await UsersAPIService.getMe();
            var uri = `/${encodeURI(user.MelcoUsername)}/Designs/GetMetaData?ReferenceID=${referenceId}&format=json`;
            uri += `&LDFAuth=${getAuthString(user.MelcoUsername, user.MelcoApiKey, uri)}`;
            var config = {
                method: 'GET',
                url: `${baseURL}${uri}`,
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                cache: false
            };

            return HttpService.get('', null, config);
        }

        return {
            getMetaData: getMetaData
        };
    }
})();
